/* eslint-disable no-underscore-dangle */
import React, { FC } from "react";
import { Avatar, Button, Flex, Typography } from "antd";
import styles from "./ChatMsgGroup.module.less";
import { ZRCMessage } from "../../../rocketChat/rocketChat.types";
import { ChatMsg } from "./ChatMsg/ChatMsg";
import { ChatFormStore } from "../../ChatFormStore";
import { createChatMsg } from "../../createChatMsg";
import { ReplyMsg } from "./ReplyMsg";

type Props = { msgGroup: ZRCMessage[]; store: ChatFormStore };

export const ChatMsgGroup: FC<Props> = ({ msgGroup, store }) => (
  <div className={styles.msgGroup}>
    <div className={styles.msgGroupContent}>
      {msgGroup.map((msg) => (
        <ChatMsgGroupItem key={msg._id} rcMsg={msg} store={store} />
      ))}
    </div>
  </div>
);

interface PropsChatMsgGroupItem {
  rcMsg: ZRCMessage;
  store: ChatFormStore;
}

const ChatMsgGroupItem: FC<PropsChatMsgGroupItem> = ({ rcMsg, store }) => {
  const { _id, u, attachments, msg } = rcMsg;
  const createMsg = (text: string) =>
    createChatMsg(text, Object.values(store.personsDict));
  const replyMsg = store.findReplyMsg(msg);
  return (
    <div key={_id} className={styles.msgGroupMsgList}>
      <div>
        <Avatar icon={u?.username[0]} />
      </div>
      <Flex vertical gap={4} align="start">
        <div className={styles.userName}>
          <Typography.Text type="secondary">{u?.username}</Typography.Text>
        </div>
        {replyMsg && (
          <ReplyMsg key={replyMsg._id} msg={replyMsg} renderText={createMsg} />
        )}
        <ChatMsg
          key={_id}
          attachments={
            attachments?.map((a, i) => ({ ...a, key: `${_id}:${i}` })) || []
          }
          msgText={msg}
          renderParams={{ createMsg }}
        />
        <Button
          type="text"
          size="small"
          onClick={() => store.setReplyMsgId(_id)}
          className={styles.reply}
        >
          <Typography.Text type="secondary">Reply</Typography.Text>
        </Button>
      </Flex>
    </div>
  );
};
